import {
  clearServiceTargetContract,
  rememberServiceTargetContract,
} from './serviceTargetContract.js';

/** Migrate the legacy provider/service pair used by Call Service (Advanced). */
export function normalizeAdvancedCallService(action) {
  if (!action) return '';

  const service = String(action.service ?? '');
  if (!service.includes('.') && action.provider && service) {
    action.service = `${action.provider}.${service}`;
  }
  delete action.provider;
  return String(action.service ?? '');
}

/** Store a picker selection as the complete Home Assistant action identifier. */
export function setAdvancedCallService(action, identifier, serviceOption = null) {
  if (!action) return;
  action.service = String(identifier ?? '');
  delete action.provider;
  if (serviceOption) rememberServiceTargetContract(action, serviceOption);
  else clearServiceTargetContract(action);
}

/** Store an Advanced action's selected target using HA's structured target. */
export function setAdvancedCallServiceTarget(action, targetOrEntityId) {
  if (!action) return;
  const target = targetOrEntityId && typeof targetOrEntityId === 'object'
    ? targetOrEntityId
    : { entity_id: String(targetOrEntityId ?? '') };
  action.target = { ...(action.target ?? {}), ...target };
  if (target.entity_id !== undefined) {
    action.parameters = (action.parameters ?? []).filter(parameter => parameter.key !== 'entity_id');
  }
}

/** Read static entity targets from structured or pre-target-model saved actions. */
export function advancedCallServiceTargetIds(action) {
  const target = action?.target?.entity_id;
  if (Array.isArray(target)) return target.filter(id => typeof id === 'string' && id.trim());
  if (typeof target === 'string' && target.trim() && !target.includes('{{')) return [target];

  const value = action?.parameters?.find(parameter => parameter.key === 'entity_id')?.value;
  if (value?.kind === 'list' && Array.isArray(value.items)) {
    return value.items.filter(id => typeof id === 'string' && id.trim());
  }
  const legacyTarget = value?.toString?.();
  return typeof legacyTarget === 'string' && legacyTarget.trim() && !legacyTarget.includes('{{')
    ? [legacyTarget]
    : [];
}
